// V9.24 · Lembrete na tela: 2 dias antes e no dia do vencimento
import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, BellRing, CalendarClock, X } from 'lucide-react';
import api from '@/lib/api';

const money = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

export const LembretesBanner = ({ onVerContasPagar, refreshKey }) => {
  const [data, setData] = useState(null);
  const [fechado, setFechado] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/fin/ledger/reminders');
        setData(res.data);
      } catch (_) { /* bloco secundário */ }
    })();
  }, [refreshKey]);

  if (!data || (!data.total && !data.orcamento?.estourados) || fechado) return null;

  const { vencido = [], hoje = [], dois_dias: dois = [] } = data.grupos || {};
  const orcAlertas = data.orcamento?.alertas || [];
  const grave = vencido.length > 0 || hoje.length > 0 || (data.orcamento?.estourados || 0) > 0;
  const linhas = [...vencido, ...hoje, ...dois].slice(0, 4);

  return (
    <div data-testid="lembretes-banner"
      className={`rounded-xl border p-4 ${grave
        ? 'border-rose-300 bg-rose-50/80' : 'border-amber-300 bg-amber-50/80'}`}>
      <div className="flex items-start gap-3">
        <div className={`rounded-lg p-2 ${grave ? 'bg-rose-500/15 text-rose-700' : 'bg-amber-500/15 text-amber-700'}`}>
          {grave ? <AlertTriangle className="w-5 h-5" /> : <BellRing className="w-5 h-5" />}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm">
            {data.total === 0 ? 'Orçamento do mês passou do planejado'
              : grave ? 'Contas a pagar exigem atenção hoje' : 'Contas a pagar vencendo em breve'}
          </p>
          <p className="text-xs text-muted-foreground">
            {data.resumo} · total {money(data.valor_total)}
          </p>
          <ul className="mt-2 space-y-1">
            {linhas.map((l) => (
              <li key={l.id} className="text-sm flex flex-wrap items-center gap-x-2"
                data-testid={`lembrete-item-${l.id}`}>
                <CalendarClock className="w-3.5 h-3.5 text-muted-foreground" />
                <span className="font-medium">{l.historico}</span>
                <span className="tabular-nums">{money(l.valor)}</span>
                <span className={`text-xs font-semibold ${l.dias_para_vencer < 0 ? 'text-rose-700'
                  : l.dias_para_vencer === 0 ? 'text-rose-600' : 'text-amber-700'}`}>
                  {l.dias_para_vencer < 0 ? `venceu há ${Math.abs(l.dias_para_vencer)} dia(s)`
                    : l.dias_para_vencer === 0 ? 'vence HOJE'
                      : `vence em ${l.dias_para_vencer} dia(s)`}
                </span>
                {l.fornecedor && <span className="text-xs text-muted-foreground">· {l.fornecedor}</span>}
              </li>
            ))}
          </ul>
          {data.total > linhas.length && (
            <p className="text-xs text-muted-foreground mt-1">
              +{data.total - linhas.length} outra(s) conta(s)
            </p>
          )}
          {!!orcAlertas.length && (
            <ul className="mt-2 space-y-1 border-t pt-2">
              {orcAlertas.map((a, i) => (
                <li key={i} className="text-sm flex items-start gap-2" data-testid={`lembrete-orcamento-${i}`}>
                  <span className={`text-xs font-bold uppercase ${a.nivel === 'danger' ? 'text-rose-700' : 'text-amber-700'}`}>
                    {a.nivel === 'danger' ? 'Orçamento estourado' : 'Orçamento'}
                  </span>
                  <span>{a.mensagem}</span>
                </li>
              ))}
            </ul>
          )}
          <Button size="sm" className="mt-3" onClick={onVerContasPagar} data-testid="lembrete-ver-contas">
            Ver contas a pagar
          </Button>
        </div>
        <Button size="sm" variant="ghost" onClick={() => setFechado(true)} data-testid="lembrete-fechar">
          <X className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default LembretesBanner;
